export default {
  desktop: 'desktop',
  tablet: 'tablet',
  mobile: 'mobile',
};
